import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon, WarningIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
const TicketOutOfSyncTooltip = ({
  isOpenConversation
}) => {
  const title = isOpenConversation ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.alerts.status-syncing.close-conversation"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.alerts.status-syncing.open-conversation"
  });
  const IconComponent = isOpenConversation ? WarningIcon : InfoIcon;
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "left",
    title: title,
    children: /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(IconHolder, {
        "data-test-id": "out-of-sync-icon",
        color: isOpenConversation ? 'fill-caution-default' : 'icon-core-subtle',
        size: "300",
        icon: IconComponent
      })
    })
  });
};
TicketOutOfSyncTooltip.displayName = 'TicketOutOfSyncTooltip';
export default TicketOutOfSyncTooltip;